var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5356 3.46449C17.4882 5.4171 17.4882 8.58292 15.5356 10.5355C13.583 12.4881 10.4172 12.4881 8.46458 10.5355C6.51197 8.58292 6.51197 5.4171 8.46458 3.46449C10.4172 1.51184 13.583 1.51184 15.5356 3.46449Z",
    fill: "#4F565E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6697 15.6028C15.1116 12.523 8.88842 12.523 4.33031 15.6028C3.65403 16.0594 3.25 16.8309 3.25 17.6671V21.9993H20.75V17.6671C20.75 16.8309 20.3459 16.0594 19.6697 15.6028Z",
    fill: "#4F565E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPerson);
export default __webpack_public_path__ + "static/media/contact-person.8bdc5a73732cd6795c4990877134b1a4.svg";
export { ForwardRef as ReactComponent };